import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {PAGES_AND_PATHS} from '../../constants/pages-and-paths';
import {AuthenticationHelperService} from '../../services/helpers/authentication-helper.service';
import {BusinessProfilesHttpService} from '../../services/http-services/business-profiles/business-profiles-http.service';
import {GeneralHelperService} from '../../services/helpers/general-helper.service';
import {distinctUntilChanged, takeUntil} from 'rxjs/operators';
import {Subject, Subscription} from 'rxjs';
import {NotificationsModelTypeAdmin} from '../../enums/notification-enums';
import {NotificationsHttpService} from '../../services/http-services/notifications/notifications-http.service';
import {WebsocketsHelperService} from '../../services/helpers/websockets-helper.service';
import {NotificationsHelperService} from '../../services/helpers/notifications-helper.service';
import {ReservationsHttpService} from '../../services/http-services/reservations/reservations-http.service';

@Component({
  selector: 'gr-side-menu',
  templateUrl: './side-menu.component.html',
})
export class SideMenuComponent implements OnInit, OnDestroy {
  private newBusinessChange = new Subject<void>();
  private newBusinessPreviousValue: any;
  isPagesDropdownOpen = false;
  isBusinessUsersDropdownOpen = false;
  isLandingDropdownOpen = false;
  businessCategories: any[] = [];
  uncategorizedBusiness: any;
  allBusinesses: any;
  inactiveBusinesses: any;
  notificationsCount = 0;
  unreadNotificationsCountSubscription = new Subscription();
  wsNotificationsSubscription = new Subscription();
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;
  urlParams = {page: 1};
  reservationsNotificationsCount!: number;
  businessNotificationCount!: number;
  unreadBusinessNotificationCountSubscription = new Subscription();
  unreadReservationsNotificationsCountSubscripton = new Subscription();

  constructor(public authHelper: AuthenticationHelperService,
              private generalHelper: GeneralHelperService,
              private _changeDetectorRef: ChangeDetectorRef,
              private notificationsHttpService: NotificationsHttpService,
              private websocketsHelperService: WebsocketsHelperService,
              private notificationsHelperService: NotificationsHelperService,
              private businessProfilesHttpService: BusinessProfilesHttpService,
              private reservationsHttpService: ReservationsHttpService
  ) {
  }

  ngOnInit(): void {
    this.getBusinessCategories();
    this.setupSomeOfNewBusinessesChangeProfileData();
    this.getAllUnreadNotificationsCount();
    this.getBusinessUnreadNotificationsCount();
    this.getReservationsNotifications();
    this.wsNotificationsSubscription = this.websocketsHelperService.notificationReceivedSubject.subscribe((res: any) => {
      console.log('wsNotificationsSubscription', res);
      this.notificationsCount++;
      if (res !== null && ([
          NotificationsModelTypeAdmin.reservationCreatedAdmin,
          NotificationsModelTypeAdmin.reservationCreatedAdminGifts,
        ].includes(res.type))) {
        this.reservationsNotificationsCount++;
      }
    });
    this.unreadNotificationsCountSubscription = this.notificationsHelperService.unreadNotificationsCountChange.subscribe((res: any) => {
      if (this.notificationsCount) {
        this.notificationsCount === 0 ? this.notificationsCount = 0 : this.notificationsCount--;
      }
    });
    this.unreadBusinessNotificationCountSubscription = this.notificationsHelperService.unreadBusinessNotificationsCountChange.subscribe((res: any) => {
      if (this.businessNotificationCount) {
        this.businessNotificationCount === 0 ? this.businessNotificationCount = 0 : this.businessNotificationCount--;
      }
    });
    this.unreadReservationsNotificationsCountSubscripton = this.notificationsHelperService.unreadReservationsNotificationsCountChange.subscribe((res: any) => {
      this.reservationsNotificationsCount === 0 ? this.reservationsNotificationsCount = 0 : this.reservationsNotificationsCount--;
    });
  }

  ngOnDestroy(): void {
    this.unreadNotificationsCountSubscription.unsubscribe();
    this.wsNotificationsSubscription.unsubscribe();
    this.newBusinessChange.next();
    this.newBusinessChange.complete();
  }

  getAllUnreadNotificationsCount(): void {
    this.notificationsHttpService.getAllNotificationsCount().then((res: any) => {
      this.notificationsCount = res.unread_count;
    });
  }

  getReservationsNotifications(): void {
    this.urlParams.page = 1;
    // this.notificationsHttpService.getReservationsNotifications(this.urlParams).then((res: any) => {
    //   this.reservationsNotificationsCount = res.unreadCount;
    // });
    this.reservationsHttpService.getSidemenuNotificaitonsUnreadCOuntReservtions().then((res: any) => {
        this.reservationsNotificationsCount = res.unread_active_reservation_count;
      });
  }

  getBusinessUnreadNotificationsCount(): void {
    this.notificationsHttpService.getBusinessNotificationsCount().then((res: any) => {
      this.businessNotificationCount = res.unread_count;
    });
  }

  setupSomeOfNewBusinessesChangeProfileData(): void {
    this._changeDetectorRef.detectChanges();
    this.generalHelper.getChangeSomeBusinessProfile().pipe(
      distinctUntilChanged(),
      takeUntil(this.newBusinessChange)
    ).subscribe((value) => {
      if (this.uncategorizedBusiness && (!this.newBusinessPreviousValue || value.businessId !== this.newBusinessPreviousValue.businessId)) {
        this.uncategorizedBusiness.companies_count -= 1;
        this.businessCategories[value.categoryId - 1].companies_count += 1;
        this.newBusinessPreviousValue = value;
      }
    });
  }

  getBusinessCategories(): void {
    this.businessProfilesHttpService.getBusinessCategories().then(res => {
      this.businessCategories = res.data.data;
    });
    this.businessProfilesHttpService.getUncategorizedBusinesses().then(res => {
      this.uncategorizedBusiness =  res.data;
    });
    this.businessProfilesHttpService.getAllBusinesses().then(res => {
      this.allBusinesses =  res.data;
    });
    this.businessProfilesHttpService.getInactiveBusinesses().then(res => {
      this.inactiveBusinesses =  res.data;
    });
  }

  handleOpenPagesDropdown(): void {
    this.isPagesDropdownOpen = !this.isPagesDropdownOpen;
  }

  handleOpenBusinessUsersDropdown(): void {
    this.isBusinessUsersDropdownOpen = !this.isBusinessUsersDropdownOpen;
  }
}
